import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import styled from "styled-components";

function ScrollButton() {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <Button>
      <img
        src={require("../../assets/img/ArrowIcon.png").default}
        height="40px"
        icon={faArrowCircleUp}
        onClick={scrollToTop}
        style={{ display: visible ? "inline" : "none" }}
      />
      {/* <FontAwesomeIcon
        size="x"
        icon={faArrowCircleUp}
        onClick={scrollToTop}
        style={{ display: visible ? "inline" : "none" }}
        color="red"
      /> */}
    </Button>
  );
}

// const Heading = styled.h1`
//   text-align: center;
//   color: green;
// `;

// const Content = styled.div`
//   overflowy: scroll;
//   height: 2500px;
// `;

const Button = styled.div`
  position: fixed;
  width: 100%;
  left: 2%;
  bottom: 70px;
  height: 20px;
  font-size: 3rem;
  z-index: 8;
  cursor: pointer;
  color: green;
`;

export default ScrollButton;
